import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "chat-container" }
const _hoisted_2 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_3 = {
  key: 2,
  class: "error-msg"
}

import TUICustomerServer, { CustomerServiceChat } from './ai-desk-customer-vue';
import { onMounted, ref, onUnmounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const status = ref<'loading' | 'ready' | 'error'>('loading');
let authTimeout: ReturnType<typeof setTimeout>;

const isReady = ref(false);

const isSdkReady = ref(false);
let pendingClearUnread = false;


const lastCredentials = ref<{ sdkAppId: number; userID: string; userSig: string } | null>(null);

const handleMessage = async (event: MessageEvent) => {
  // SECURITY CHECK: Ensure the message is actually coming from your website
  console.log("message receive: ",event.data.type);
  const trustedDomains = ['ballys.itone.biz', 'ballysbet.com', 'bellagio.itone.biz', 'win365casino.com', 'localhost'];

    //https://ballys.itone.biz
  const domain = new URL(event.origin).hostname || "";

   if (trustedDomains.indexOf(domain) == -1){
       console.log("unauthorized domain: ",domain);
       return;
   }

  try {

    if (event.data && event.data.type === 'INIT_CHAT') {
      if (!event.data.userID || !event.data.userSig) {
        throw new Error("Missing credentials in message");
      }
      console.log("SDKAppID: ",event.data.sdkAppId);
      clearTimeout(authTimeout);
      lastCredentials.value = event.data;
      await TUICustomerServer.initWithProfile({
        SDKAppID: event.data.sdkAppId,
        userID: event.data.userID,
        userSig: event.data.userSig,
        nickName: event.data.userID
      });
      isReady.value = true; // Show the widget
      status.value = 'ready';
      isSdkReady.value = true;
      if (pendingClearUnread) {
        TUICustomerServer.clearConversationUnreadCount();
        pendingClearUnread = false;
      }      
    }
    if (event.data?.type === 'CLEAR_UNREAD') {
      if (isSdkReady.value) {
        TUICustomerServer.clearConversationUnreadCount();
      } else {
        // login is still in flight — apply it as soon as init finishes above
        pendingClearUnread = true;
      }
    }

    if (event.data?.type === 'CHAT_PANEL_CLOSED') {
      await TUICustomerServer.unInit();
    }

    if (event.data?.type === 'CHAT_PANEL_REOPENED') {
      if (!lastCredentials.value) {
        console.warn('CHAT_PANEL_REOPENED received before any credentials were set');
        return;
      }      
      await TUICustomerServer.initWithProfile({
        SDKAppID: lastCredentials.value.sdkAppId,
        userID: lastCredentials.value.userID,
        userSig: lastCredentials.value.userSig,
        nickName: lastCredentials.value.userID
      });
      isSdkReady.value = true;
      if (pendingClearUnread) {
        TUICustomerServer.clearConversationUnreadCount();
        pendingClearUnread = false;
      }      
    }
        
  } catch (error) {
    console.error('Chat initialization failed:', error);
    status.value = 'error';
  }
}

onMounted(() => {
  // Start listening for messages from the parent website
  window.addEventListener("message", handleMessage);
  authTimeout = setTimeout(() => {
      if (status.value === 'loading') {
        console.warn("Chat Widget: Credential timeout reached.");
        status.value = 'error';
      }
    }, 5000);
});

onUnmounted(() => {
  // Clean up the listener when the component is destroyed
  window.removeEventListener("message", handleMessage);
  clearTimeout(authTimeout);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (status.value === 'ready')
      ? (_openBlock(), _createBlock(_unref(CustomerServiceChat), {
          key: 0,
          style: { width: '600px', height: '96vh', margin: '1px auto', boxShadow: '0 5px 20px #ccc' }
        }))
      : (status.value === 'loading')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Connecting to secure server... "))
        : (status.value === 'error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("p", null, "Authentication failed. Please refresh the page.", -1)
            ]))]))
          : _createCommentVNode("", true)
  ]))
}
}

})